﻿/**
 * Backend UTC ISO string döner (ör: "2026-06-15T19:00:00Z").
 * <input type="datetime-local"> ise "2026-06-15T19:00" formatını bekler (yerel saatte).
 * Bu iki yönlü dönüşüm için helper'lar.
 *
 * NOT: Browser Date() otomatik yerel saate çevirir, sonra `toISOString()` UTC'ye çevirir.
 * Bu sadece MVP için yeterli — ileride timezone picker (event.timezone) eklenebilir.
 */

import type { Format } from "@/lib/format";

/** ISO UTC string → "YYYY-MM-DDTHH:mm" (yerel). Input'a koymak için. */
export function isoToLocalInput(iso: string | null | undefined): string {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  const pad = (n: number) => n.toString().padStart(2, "0");
  return (
    `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}` +
    `T${pad(d.getHours())}:${pad(d.getMinutes())}`
  );
}

/** "YYYY-MM-DDTHH:mm" (yerel input) → ISO UTC string. Backend'e göndermek için. */
export function localInputToIso(local: string | null | undefined): string | null {
  if (!local) return null;
  const d = new Date(local);
  if (Number.isNaN(d.getTime())) return null;
  return d.toISOString();
}

/** UI'da gösterim için: "15 Haz 2026, 19:00" (aktif dile göre). */
export function formatEventDate(iso: string | null | undefined, fmt: Format): string {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  return fmt.dateTime(d, {
    day: "numeric",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}
